import {styled} from '@mui/material/styles';
import CircularProgress, {CircularProgressProps} from "@mui/material/CircularProgress";

export const CCircularProgress = styled(CircularProgress)<CircularProgressProps>(
  (/* { theme } */) => ({
  }),
);
